import React from 'react';
import { PolicySummaryFacade } from '~domain/model/facade/policy/policy-summary-facade';
import { PolicyIssuance } from '~domain/model/policy/policy-issuance';
import { useTranslator } from '~frontend-common/i18n/translator';
import { Tag } from '~ui-kit/components/tag';
import { theme } from '~ui-kit/theme';

interface PolicyTagProps {
  policy: PolicySummaryFacade;
  isRenewal: boolean;
}

export function PolicyTag({ policy, isRenewal }: PolicyTagProps) {
  const { t } = useTranslator();

  if (policy.issuance === PolicyIssuance.Cancelled) {
    return (
      <Tag color={theme.colors.red.normal} background={theme.colors.red.lighter} fontSize="13px">
        {t('policies.policyCard.tag.cancelled')}
      </Tag>
    );
  }

  if (policy.isExpired) {
    return (
      <Tag color={theme.colors.black} background={theme.colors.lightGray} fontSize="13px">
        {t('policies.policyCard.tag.expired')}
      </Tag>
    );
  }

  if (isRenewal) {
    return (
      <Tag color={theme.colors.green.dark} background={theme.colors.green.lighter} fontSize="13px">
        {t('policies.policyCard.tag.renewal')}
      </Tag>
    );
  }

  return null;
}
